import { fetchAllSubmodules } from "@/apis/config/configApi";
import DataTable from "@/common/elements/DataTable";
// import DraggableDataTable from "@/common/elements/DraggableDataTable";
import { StyledReportContainer } from "@/components/CommonReport/styles";
import { StyledFlex } from "@/common/styles";
import Button from "@/common/elements/Button";
import { forwardRef, useEffect } from "react";
import { useDispatch } from "react-redux";

// Matches legacy ListID "Bookings" (BookingsSummaryInterface.asp,
// GetModuleName() = "Bookings Summary") — a separate cross-module summary
// screen from the Bookings record interface itself (GetModuleName =
// "Bookings"), reused as-is here since this one React component is shared
// between the main Bookings module's own search list and Inmate Movement's
// embedded copy. Exported so both parents can pass it to their own
// `useGridColumnConfig(...)` call as `defaultHeaders` — see the `headers`/
// `draggable`/`ref` props below. Config used to be wired entirely inside
// this component with no parent involvement, but that meant the actual
// Config *button* had nowhere in either parent's toolbar to render, so it
// silently never appeared anywhere — moved the hook up to each parent
// (same pattern as every other screen in this rollout) so the button can
// sit in the existing Show-Filter toolbar row like everywhere else.
export const REPORT_LIST_HEADERS = [
  { key: "bookingNumber", text: "Booking Number" },
  { key: "name", text: "Full Name" },
  { key: "dob", text: "Date of Birth" },
  { key: "incarcerationDate", text: "Incarceration Date" },
  { key: "releaseDate", text: "Release Date" },
  { key: "housingAgency", text: "Housing Agency" },
  { key: "housingLocation", text: "Current Location" },
];

const ReportList = forwardRef(({
  results,
  selectBookingNumber,
  isLoading,
  pagination,
  setPagination,
  total,
  handleChangePagination,
  setSaveVisible,
  getReportListData,
  onTableChange,
  headers = REPORT_LIST_HEADERS,
  draggable = false,
}, ref) => {
  const dispatch = useDispatch();
  const result = results?.map((res) => {
    return {
      ...res,
      name: `${res?.lastname ? res.lastname + ',' : ''} ${res?.firstName || ''}${res?.middleName ? ' ' + res.middleName : ''}${res?.suffix ? ', ' + res.suffix : ''}`.trim(),
    };
  });

  const handleRowClick = (data, index) => {
    if (data?.bookingNumber && index !== undefined && index !== null) {
      selectBookingNumber(data?.bookingNumber);
    }
  };

  useEffect(() => {
    // setLocalSubModules(selectOptions)
    dispatch(fetchAllSubmodules());
    setSaveVisible(false);
    // getReportListData();
  }, []);

  return (
    <StyledReportContainer>
       <DataTable
        ref={ref}
        rowUniqueId={"bookingNumber"}
        allowTableSorting={true}
        serverSideSorting={true}
        onTableChange={onTableChange}
        headers={headers}
        width="100%"
        className="table-striped"
        selectionColumnVisible={false}
        isAPiCallLoading={isLoading}
        data={result || []}
        onRowClick={handleRowClick}
        pagination={pagination}
        setPagination={setPagination}
        totalRecords={total}
        onPageChange={handleChangePagination}
        draggable={draggable}
      />
    </StyledReportContainer>
  );
});

export default ReportList;
